import React,{useState,useEffect, useContext} from 'react';
import { Col,Form } from 'react-bootstrap';
import { AuthContext } from '../../auth/AuthContext';

const SelectItemOficinas = ({props}) => {

  const {usuario} = useContext(AuthContext)

  const [data,setData] = useState([])

  useEffect(() => {
    getOnlyNamesOficinas()
  },[])

  return(
    <Col xs={12} md={4}>
      <React.Fragment>
        <h3 className="ws_select_type">Oficinas</h3>
        <Form.Select 
        aria-label="select agentes" 
        {...props}
        >
          <option value="">TODOS</option>
          {
            (data.length>0) ?
              data.map((t,e)=> (
                <option value={t.clave_oficina}>{t.nombre_oficina}</option>
              ))
            : null
          }
        </Form.Select>
      </React.Fragment>
    </Col>
  )
  
  function getOnlyNamesOficinas(){
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getOnlyNamesOficinas`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({id_login: usuario.id_usuario,})
    })
    .then(res => res.json())
    .then((res) => {
      setData(res.list)
    })
  }

}

const SelectItemOficinas2 = ({props}) => {

  const {usuario} = useContext(AuthContext)

  const [data,setData] = useState([])

  useEffect(() => {
    getOnlyNamesOficinas()
  },[])

  return(
    <Col xs={12} md={4}>
      <React.Fragment>
        <h3 className="ws_select_type">Oficinas</h3>
        <Form.Select 
        aria-label="select agentes" 
        {...props}
        >
          <option value="">ELIGE UNA OPCIÓN</option>
          {
            (data.length>0) ?
              data.map((t,e)=> (
                <option value={t.clave_oficina}>{t.nombre_oficina}</option>
              ))
            : null
          }
        </Form.Select>
      </React.Fragment>
    </Col>
  )
  
  function getOnlyNamesOficinas(){
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getOnlyNamesOficinas`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({id_login: usuario.id_usuario,})
    })
    .then(res => res.json())
    .then((res) => {
      setData(res.list)
    })
  }

}

export const SelectOficinas = ({...props}) => {
  return(
    <SelectItemOficinas props={props} />
  )
}

export const SelectOficinas2 = ({...props}) => {
  return(
    <SelectItemOficinas2 props={props} />
  )
}
